module.exports = __webpack_public_path__ + "static/media/ot-courier-default.81b7e80a.svg";